import { Box, Typography } from '@mui/material';

import { useWalletElementContext } from '../views/WalletView';

import { PaginatedDealsTable } from './PaginatedDealsTable';

export const MyDeals = () => {
    const { myDealsRef } = useWalletElementContext();

    // if (deals && deals.length !== 0) {
    //     deals.sort((a, b) => {
    //         return new Date(b.funded_date).valueOf() - new Date(a.funded_date).valueOf();
    //     });
    // }

    return (
        <Box mt={3.5} pt={2} sx={{ minHeight: '100%' }} ref={myDealsRef}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" flexDirection="row" flexWrap="wrap" alignItems="center">
                    <Typography mb={0.5} variant="h5">
                        Deals
                    </Typography>
                </Box>
            </Box>
            <Box mt={2}>
                {/* {deals && deals.length !== 0 ? (
                    <StaticTable
                        columns={columns}
                        data={deals.map(
                            ({
                                id,
                                invoice_number,
                                funded_date,
                                product_name,
                                total_collected,
                                payback_amount,
                                deal_status,
                                gross_funded_amount,
                                status,
                            }) => ({
                                id,
                                invoice_number,
                                funded_date,
                                product: product_name,
                                amount: gross_funded_amount,
                                paid: payback_amount ? total_collected / payback_amount : 0,
                                deal_status:
                                    status === DealDisplayStatus.Rejected ? status : deal_status,
                            })
                        )}
                        handleTableRowClick={handleTableRowClick}
                    />
                ) : (
                    <Typography variant="body1">You don't have any deals yet</Typography>
                )} */}
                <PaginatedDealsTable />
            </Box>
        </Box>
    );
};
